import * as React from "react";
import {observer} from "mobx-react-lite";
import {
    CButton,
    CCard,
    CCardContent,
    CContainer,
    CGrid,
    CGridContainer, CH3,
    CTextField
} from "../../components";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import {hasValue} from "../../utils/empty-check";
import {isEmpty} from "validate.js";
import 'firebase/compat/firestore';
import {CCircularProgress} from "../../components/mui-extracted/circular-progress";
import {useStores} from "../../models";
import {cast} from "mobx-state-tree";
import {fetchSignInMethodsForEmail} from "firebase/auth";
import {auth} from "../../firebase";

export const Submit = observer(
    function Submit() {

        const navigate = useNavigate();
        const {businessStore} = useStores();

        const [formData, setFormData] = useState({
            name: "",
            owner: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            country: "",
            zip: "",
            phoneNumber: "",
            email: "",
        })

        const [formDataValidationMessages, setFormDataValidationMessages] = useState({
            name: "",
            owner: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            country: "",
            zip: "",
            phoneNumber: "",
            email: "",
        })

        const [isSubmitting, setIsSubmitting] = useState(false)

        const isValid = () => {

            let output = true

            const currentFormDataValidationMessages = {
                ...formDataValidationMessages
            }

            if (isEmpty(formData.name)) {
                currentFormDataValidationMessages.name = "Name is required."
                output = false
            }

            if (isEmpty(formData.owner)) {
                currentFormDataValidationMessages.owner = "Owner is required."
                output = false
            }

            if (isEmpty(formData.address1)) {
                currentFormDataValidationMessages.address1 = "Address 1 is required."
                output = false
            }

            if (isEmpty(formData.address2)) {
                currentFormDataValidationMessages.address2 = "Address 2 is required."
                output = false
            }

            if (isEmpty(formData.city)) {
                currentFormDataValidationMessages.city = "City is required."
                output = false
            }

            if (isEmpty(formData.state)) {
                currentFormDataValidationMessages.state = "State is required."
                output = false
            }

            if (isEmpty(formData.country)) {
                currentFormDataValidationMessages.country = "Country is required."
                output = false
            }

            if (isEmpty(formData.zip)) {
                currentFormDataValidationMessages.zip = "Zip is required."
                output = false
            }

            if (isEmpty(formData.phoneNumber)) {
                currentFormDataValidationMessages.phoneNumber = "Phone Number is required."
                output = false
            }

            if (isEmpty(formData.email)) {
                currentFormDataValidationMessages.email = "Email is required."
                output = false
            }

            if (!output) {
                setFormDataValidationMessages(currentFormDataValidationMessages)
            }

            return output
        }

        const submit = async () => {
            if (isValid()) {
                setIsSubmitting(true)
                const signInMethods = await fetchSignInMethodsForEmail(auth, formData.email)
                if (signInMethods.length > 0) {
                    setFormDataValidationMessages({
                        ...formDataValidationMessages,
                        email: "This email address is already taken."
                    })
                    setIsSubmitting(false)
                    return;
                }

                await businessStore.submitBusiness(formData);

                setIsSubmitting(false)
                navigate('/submit-message')
            }
        }

        return (
            <>
                <main style={{minHeight: '100vh'}}>
                    <CContainer
                        style={{display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center'}}>
                        <CCard sx={{width: 600}}>
                            <CCardContent sx={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}>

                                <CGridContainer>
                                    <CGrid item xs={12}>
                                        <CH3 sx={(theme) => ({
                                            fontWeight: 900,
                                            mb: 2,
                                            color: theme.palette.primary.light
                                        })}>
                                            Build With Abeld
                                        </CH3>
                                    </CGrid>
                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.name)}
                                            helperText={formDataValidationMessages.name}
                                            label="Name"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.name}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    name: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.owner)}
                                            helperText={formDataValidationMessages.owner}
                                            label="Owner"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.owner}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    owner: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.address1)}
                                            helperText={formDataValidationMessages.address1}
                                            label="Address 1"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.address1}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    address1: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.address2)}
                                            helperText={formDataValidationMessages.address2}
                                            label="Address 2"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.address2}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    address2: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.city)}
                                            helperText={formDataValidationMessages.city}
                                            label="City"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.city}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    city: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.state)}
                                            helperText={formDataValidationMessages.state}
                                            label="State"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.state}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    state: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.country)}
                                            helperText={formDataValidationMessages.country}
                                            label="Country"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.country}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    country: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.zip)}
                                            helperText={formDataValidationMessages.zip}
                                            label="Zip"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.zip}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    zip: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.phoneNumber)}
                                            helperText={formDataValidationMessages.phoneNumber}
                                            label="Phone Number"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.phoneNumber}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    phoneNumber: event.target.value
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6}>
                                        <CTextField
                                            error={hasValue(formDataValidationMessages.email)}
                                            helperText={formDataValidationMessages.email}
                                            label="Email"
                                            variant="standard"
                                            sx={{
                                                mb: 2
                                            }}
                                            value={formData.email}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setFormData({
                                                    ...formData,
                                                    email: event.target.value.trim()
                                                });
                                            }}
                                        />
                                    </CGrid>

                                    <CGrid item xs={6} sx={{mt: 2}}>
                                        {
                                            isSubmitting ? <CCircularProgress/> :
                                                <CButton disabled={isSubmitting} size="medium" variant="contained"
                                                         onClick={() => submit()}>
                                                    Submit
                                                </CButton>
                                        }

                                    </CGrid>

                                </CGridContainer>


                            </CCardContent>
                        </CCard>
                    </CContainer>
                </main>
            </>
        );
    }
)
